import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import * as Snackbar from "node-snackbar";
import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
import { BooleanCellType } from "@/components/table/cell/FCellBooleanMDP";
import FCellDateMDP from "@/components/table/cell/FCellDateMDP";
import FCellTextEllipsisMDP from "@/components/table/cell/FCellTextEllipsisMDP";
import FInfoINRMDP from "@/components/table/info/FInfoINRMDP";
import { InfoPosition } from "@/components/table/FTableInfoMDP";
import FInfoCreditorWarningMDP from "@/components/table/info/FInfoCreditorWarningMDP";
export default class FCreditorListFDataTableMDP extends FDataTableMDP {
    parent: any;
    constructor(props:{parent: any}) {
        super({myRefName:"fCreditorListFDataTableRef", enableSearch: true, disabled: props.parent.disabled, itemKey:"fiCreditorId",
      title:"Included Creditors",enableFooter: true});
        this.parent = props.parent;
        this.addColumn({
            label: "Creditor Name",
            dataSelectorKey: "creditorName",
          })
          .addBooleanColumn({
            label: "",
            dataSelectorKey: "creditorMasterInfo.isServicedByFreed",
            type: BooleanCellType.Dotted,
          })
          .addCurrencyColumn({
            label: "Creditor Balance",
            dataSelectorKey: "creditorBalance",
          })
          .addCurrencyColumn({
            label: "EMI Amount",
            dataSelectorKey: "emiAmount",
          })
          .addCurrencyColumn({
            label: "Overdue Amount",
            dataSelectorKey: "creditorAmountOverdue",
            hidden: true
          })
          
          .addColumn({
            label: "Last Date Of Payment",
            dataSelectorKey: "lastDateOfPayment",
            columnCellMDP: new FCellDateMDP(),
            align: 'right'
          })
          .addNumberColumn({
            label: "Delinquency(at Creditpull)",
            dataSelectorKey: "daysDelinquentAsOnOnboarding",
          })
          .addNumberColumn({
            label: "Delinquency(at Enrolment)",
            dataSelectorKey: "daysDelinquentAsOnEnrolment",
          })
          .addNumberColumn({
            label: "Delinquency(as on date)",
            dataSelectorKey: "currentDelinquency",
          })
          .addColumn({
            label: "Debt Type",
            dataSelectorKey: "debtType",
          }).addColumn({
            label: "Account Number",
            dataSelectorKey: "accountNumber",
          })
          .addColumn({
            label: "Details",
            dataSelectorKey: "details",
            columnCellMDP: new FCellTextEllipsisMDP(),
          })
          .addAction({
            type: ActionType.DELETE,
            onClick: this.handleExcludeInProgram(),
            label: "",
            confirmation: true
          }).addAction({
            type: ActionType.EDIT,
            onClick: item => this.selectEditCreditor(item),
            label: "",
            confirmation: true
          }).addAction({
            type: ActionType.ADD,
            onClick: item => this.handleAddClick(),
            label: "Add Creditor",
          })
          // .addAction({
          //   type: ActionType.OTHERS,
          //   onClick: item => this.handleAddCreditorFromPDF(),
          //   label: "Upload Credit Report PDF",
          //   noSelect: true
          // })
          .addAction({
            type: ActionType.OTHERS,
            onClick: item => this.handleAddCreditScore(),
            label: "Update Credit Score",
            noSelect: true
          })
          // .addAction({
          //   type: ActionType.OTHERS,
          //   onClick: this.handleExcludeInProgram(),
          //   label: "Exclude from program",
          //   singleSelect: true,
          //   confirmation: true
          // })
          .addBooleanColumn({
            label: "InEligible",
            dataSelectorKey: "ineligible",
            hidden: true
          }).addBooleanColumn({
            label: "Exception Taken",
            dataSelectorKey: "exceptionTaken",
            hidden: true
          })
          .addBooleanColumn({
            label: "Is CC FullPayment",
            dataSelectorKey: "isCCFullPayment",
            hidden: true
          })

          .addNumberColumn({
            label: "No Of Payments",
            dataSelectorKey: "noOfPayments",
            hidden: true
          })

          .addNumberColumn({
            label: "Amount Paid AfterLPD",
            dataSelectorKey: "amountPaidAfterLPD",
            hidden: true
          })

          
          
          
          .addInfo({
            label: "Total Amount",
            value: this.parent.totalDebt,
            infoMDP: new FInfoINRMDP({})
          }).addInfo({
            label: "WAD",
            value: this.parent.clientFileBasicInfo.wad || 0,
          }).addInfo({
            label: "Credit Score",
            value: this.parent.clientFileBasicInfo.creditScore,
          })
          
          .addInfo({
            label: "Freed",
            value: "",
            position: InfoPosition.Footer,
            infoMDP: new FInfoCreditorWarningMDP(),
            condition: this.isNonServicableCreditorIncluded()
          });
        
    }

    isNonServicableCreditorIncluded() {
      const unServicedCreditors = this.parent.fiCreditorList?.filter((item: any) => item.creditorMasterInfo.isServicedByFreed === false) || [];
      return unServicedCreditors.length>0
    }

    


    selectEditCreditor(item: any) {
      return new Promise(resolve => {
        this.parent.selectEditCreditor(item);
      })
    }

    handleAddClick() {
      return new Promise(resolve => {
        this.parent.showAddForm();
        resolve(true);
      })
      
    }

    handleAddCreditScore() {
      return new Promise(resolve => {
        this.parent.showAddCreditScoreForm();
        resolve(true);
      })
      
    }

    handleAddCreditorFromPDF() {
      return new Promise(resolve => {
        this.parent.showParseCreditReportForm = true;
        resolve(true);
      })
    }

    handleExcludeInProgram() {
      return (item: any) => {
          return new Promise(resolve => {
              this.parent.handleExcludeInProgram(item);
              resolve(true);
            })
      }
  }
    
}